import axios from "axios"
import moment from "moment-timezone"
import {
    decompressResponse,
    fetchAlertsWeightage,
    getTodayDate
} from "../utils/functions"
import { STOCK_LIST, SECTORS } from "../constants"

const config = {
    host: process.env.REACT_APP_API_HOST,
    dataServer: process.env.REACT_APP_DATA_SERVER_API_URL,
    urls: {
        get_options: "/options",
        get_data: "/query",
        pie_charts: "/pie-charts",
        dash_table: "/dash-table-data",
        av_hic_data: "/av-hic-data",
        gtrends_hic_data: "/gtrends-hic-data",
        ibm_news_hic_data: "/ibm-news-hic-data",
        stocktwits_hic_data: "/stocktwits-hic-data",
        composite_sentiment: "/composite-sentiment",
        get_daily_graphs: "/get-daily-graphs",
        get_market_status_graphs: "/get-market-status-graphs-test",
        reddit_hic_data: "/reddit-hic-data",
        bluesky_hic_data: "/bluesky-hic-data",
        edgar_hic_data: "/edgar-hic-data",
        alerts: "/alerts",
        get_scroll: "/get-scroll"
    }
}

const get_tickers = () => STOCK_LIST

const get_sectors = () => SECTORS

const key = "prod"

const STAGING_CUTOFF = moment("2025-12-01")
const getEsEnv = (date) => {
    if (!date) return "staging"
    return moment(date).isBefore(STAGING_CUTOFF) ? "prod" : "staging"
}

const get_options = async (ticker, start_date, end_date, title_text) => {
    let body = {
        ticker: ticker,
        sdate: start_date,
        edate: end_date,
        type: "title",
        key: key,
        es_env: "staging"
    }
    const response = await axios
        .post(`${config.host}${config.urls.get_options}`, body)
        .then((response) => {
            // console.log(response, response.data_text)
            return response.data
        })
        .catch((e) => {
            console.log("Inside Error: ", e)
            return ""
        })

    const data = response.data
    let Keyword = []
    let Concept = []
    let Author = []
    let Person = []
    let Company = []

    if (data) {
        for (let d of data["Keyword"]) {
            Keyword.push({ label: d, value: d })
            // Keyword.push({ label: d, value: d.split(' ').join('_') });
        }

        for (let d of data["Concept"]) {
            Concept.push({ label: d, value: d })
        }

        for (let d of data["Author"]) {
            Author.push({ label: d, value: d })
        }

        for (let d of data["Person"]) {
            Person.push({ label: d, value: d })
        }

        for (let d of data["Company"]) {
            Company.push({ label: d, value: d })
        }
    }

    const result = {
        Author,
        Person,
        Keyword,
        Concept,
        Company
    }

    return result
}

const get_data = async (query) => {
    const sources = ["stocktwits", "ibm_news", "gtrends", "alphavantage"]
    const data = {}
    for (const source of sources) {
        const body = {
            query: query,
            source: source,
            key: key,
        es_env: "staging"
        }
        const response = await axios
            .post(`${config.host}${config.urls.get_data}`, body)
            .then((response) => {
                return response.data
            })
            .catch((e) => {
                console.log("Inside Error: ", e)
                return ""
            })
        data[source] = response.data.data
    }
    return data
}

const get_piecharts_data = async (
    query,
    dq_flag,
    weights,
    newsWeights,
    reddit_weights,
    edgarFlag
) => {
    try {
        if (query.rules.rules[0].field === null) {
            query["rules"] = []
        }
    } catch (err) {
        query["rules"] = []
    }

    let body = {
        query: query,
        key: key,
        es_env: "staging"
    }

    if (edgarFlag) {
        body = {
            ...body,
            edgar_flag: true
        }
    } else {
        body = {
            ...body,
            dq_flag: dq_flag,
            weights: weights,
            news_weights: newsWeights,
            reddit_weights: reddit_weights
        }
    }

    const response = await axios
        .post(`${config.host}${config.urls.pie_charts}`, body)
        .then((response) => {
            return response.data
        })
        .catch((e) => {
            console.log("Data Retrieval Error (Piecharts): ", e)
            return ""
        })

    const data = response.data
    return data
}

const get_dashtable_data = async (
    query,
    source,
    dq_flag,
    weights,
    newsWeights,
    reddit_weights,
    edgarFlag
) => {
    try {
        if (query.rules.rules[0].field === null) {
            query["rules"] = []
        }
    } catch (err) {
        query["rules"] = []
    }

    let body = {
        query: query,
        source: source,
        key: key,
        es_env: "staging"
    }

    if (edgarFlag) {
        body = {
            ...body,
            edgar_flag: true
        }
    } else {
        body = {
            ...body,
            dq_flag: dq_flag,
            weights: weights,
            news_weights: newsWeights,
            reddit_weights: reddit_weights
        }
    }

    const response = await axios
        .post(`${config.host}${config.urls.dash_table}`, body)
        .then((response) => {
            return JSON.parse(
                JSON.stringify(response.data).replaceAll("NaN", null)
            )
        })
        .catch((e) => {
            console.log("Data Retrieval Error (DashTable):", source, e)
            return ""
        })
    const data = response
    return data
}

const get_av_hic_data = async (query) => {
    try {
        if (query.rules.rules[0].field === null) {
            query["rules"] = []
        }
    } catch (err) {
        query["rules"] = []
    }

    const body = {
        ticker: query["ticker"],
        sdate: query["sdate"],
        edate: query["edate"],
        is_compressed: true,
        es_env: "staging"
    }

    try {
        const response = await axios.post(
            `${config.host}${config.urls.av_hic_data}`,
            body
        )

        const { data } = await decompressResponse(response.data)
        return data
    } catch (e) {
        console.log("Data Retrieval Error (AV Hic): ", e)
    }
}

const get_gtrends_hic_data = async (query) => {
    try {
        if (query.rules.rules[0].field === null) {
            query["rules"] = []
        }
    } catch (err) {
        query["rules"] = []
    }
    const body = {
        ticker: query["ticker"],
        sdate: query["sdate"],
        edate: query["edate"],
        es_env: "staging"
    }
    const response = await axios
        .post(`${config.host}${config.urls.gtrends_hic_data}`, body)
        .then((response) => {
            return response.data
        })
        .catch((e) => {
            console.log("Data Retrieval Error (GT Hic): ", e)
            return ""
        })
    const data = response.data
    return data
}

const get_ibm_news_data = async (query, dq_flag, newsWeights) => {
    try {
        if (query.rules.rules[0].field === null) {
            query["rules"] = []
        }
    } catch (err) {
        query["rules"] = []
    }
    const body = {
        query: query,
        dq_flag: dq_flag,
        key: key,
        news_weights: newsWeights,
        is_compressed: true,
        es_env: "staging"
    }

    try {
        const response = await axios.post(
            `${config.host}${config.urls.ibm_news_hic_data}`,
            body
        )

        const { data } = await decompressResponse(response.data)
        return data
    } catch (e) {
        console.log("Data Retrieval Error : get_ibm_news_data", e)
    }
}

const get_stocktwits_data = async (query, dq_flag, weights) => {
    try {
        if (query.rules.rules[0].field === null) {
            query["rules"] = []
        }
    } catch (err) {
        query["rules"] = []
    }
    const body = {
        query,
        key,
        dq_flag,
        weights,
        is_compressed: true,
        es_env: "staging"
    }

    try {
        const response = await axios.post(
            `${config.host}${config.urls.stocktwits_hic_data}`,
            body
        )

        const { data } = await decompressResponse(response.data)
        return data
    } catch (e) {
        console.log("Data Retrieval Error : stocktwits_hic_data", e)
    }
}

const get_composite_sentiment = async (
    query,
    dq_flag,
    weights,
    newsWeights,
    reddit_weights,
    edgarFlag
) => {
    try {
        if (query.rules.rules[0].field === null) {
            query["rules"] = []
        }
    } catch (err) {
        query["rules"] = []
    }

    let body = {
        query: query,
        key: key,
        es_env: "staging"
    }

    if (edgarFlag) {
        body = {
            ...body,
            edgar_flag: true
        }
    } else {
        body = {
            ...body,
            dq_flag: dq_flag,
            weights: weights,
            news_weights: newsWeights,
            reddit_weights: reddit_weights
        }
    }

    const response = await axios
        .post(`${config.host}${config.urls.composite_sentiment}`, body)
        .then((response) => {
            return response.data
        })
        .catch((e) => {
            console.log("Data Retrieval Error (Piecharts): ", e)
            return null
        })

    if (!response || !response.data) {
        console.log("No data returned from composite_sentiment API")
        return null
    }

    const data = JSON.parse(
        JSON.stringify(response.data).replaceAll("NaN", null)
    )
    return data
}

const get_graphs = async (graph_type, date = null, ticker = null) => {
    const body = {
        graph_type: graph_type,
        key: key,
        date: date ? date : null,
        ticker,
        es_env: getEsEnv(date)
    }
    const response = await axios
        .post(`${config.host}${config.urls.get_daily_graphs}`, body)
        .then((response) => {
            console.log(typeof(JSON.stringify(response.data)))
            return JSON.parse(
                JSON.stringify(response.data).replaceAll("NaN", null)
            )
        })
        .catch((e) => {
            return "GGG"
        })

    return JSON.parse(JSON.stringify(response).replaceAll("NaN", null))
}

const get_reddit_data = async (query, dq_flag, weights) => {
    try {
        if (query.rules.rules[0].field === null) {
            query["rules"] = []
        }
    } catch (err) {
        query["rules"] = []
    }

    const body = {
        query: query,
        key: key,
        dq_flag: dq_flag,
        reddit_weights: weights,
        is_compressed: true,
        es_env: "staging"
    }

    try {
        const response = await axios.post(
            `${config.host}${config.urls.reddit_hic_data}`,
            body
        )

        const { data } = await decompressResponse(response.data)
        return data
    } catch (e) {
        console.log("Data Retrieval Error : get_reddit_data", e)
    }
}

const get_bluesky_data = async (query, dq_flag) => {
    try {
        if (query.rules.rules[0].field === null) {
            query["rules"] = []
        }
    } catch (err) {
        query["rules"] = []
    }

    const body = {
        query: query,
        key: key,
        dq_flag: dq_flag,
        is_compressed: true,
        es_env: "staging"
    }

    try {
        const response = await axios.post(
            `${config.host}${config.urls.bluesky_hic_data}`,
            body
        )

        const { data } = await decompressResponse(response.data)
        return data
    } catch (e) {
        console.log("Data Retrieval Error : bluesky_hic_data", e)
    }
}

const get_edgar_data = async (query) => {
    try {
        if (query.rules.rules[0].field === null) {
            query["rules"] = []
        }
    } catch (err) {
        query["rules"] = []
    }

    const body = {
        query,
        key,
        is_compressed: true,
        es_env: "staging"
    }

    try {
        const response = await axios.post(
            `${config.host}${config.urls.edgar_hic_data}`,
            body
        )

        const { data } = await decompressResponse(response.data)
        return data
    } catch (e) {
        console.log("Data Retrieval Error (Edgar HIC): ", e)
    }
}

const get_market_status_graphs = async ({
    graph_type,
    ticker = null,
    marketStatusDate,
    market,
    days_range
}) => {
    const body = {
        graph_type,
        key,
        ticker,
        current_date: marketStatusDate,
        days_range,
        market,
        es_env: "staging"
    }
    console.log(
        "API Called with",
        `${config.host}${config.urls.get_market_status_graphs}`,
        body
    )

    const response = await axios
        .post(`${config.host}${config.urls.get_market_status_graphs}`, body)
        .then((response) => {
            return JSON.parse(
                JSON.stringify(response.data).replaceAll("NaN", null)
            )
        })
        .catch((error) => {
            return error
        })

    return JSON.parse(JSON.stringify(response).replaceAll("NaN", null))
}

const get_alerts = async (date, price_enabled = false, page = 1) => {
    try {
        const host = process.env.REACT_APP_API_HOST_DEV || config.host

        let body = {
            date,
            price_enabled,
            only_faang: false,
            page,
            es_env: getEsEnv(date),
            key: key
        }

        const alertsWeightage = fetchAlertsWeightage()

        if (alertsWeightage) {
            body = { ...body, conditions: alertsWeightage }
        }

        console.log("API called with ", body, host + config.urls.alerts)

        const response = await axios
            .post(`${host}${config.urls.alerts}`, body)
            .then((response) => {
                return response.data
            })
            .catch((e) => {
                console.log("Data Retrieval Error (Stocktwits HIC): ", e)
                return ""
            })
        const data = response.data
        return data
    } catch (err) {
        console.log("Error in get_alerts", err)
    }
}

const get_ema_alerts = async (tickers, date) => {
    try {
        const BATCH_SIZE = 20
        const start_date = moment(date).subtract(90, 'days').format('YYYY-MM-DD')
        const end_date = moment(date).format('YYYY-MM-DD')
        const emaHost = process.env.REACT_APP_API_HOST

        // Split tickers into batches to avoid Lambda timeout
        const batches = []
        for (let i = 0; i < tickers.length; i += BATCH_SIZE) {
            batches.push(tickers.slice(i, i + BATCH_SIZE))
        }

        console.log(`EmaAlerts: ${batches.length} batches of ~${BATCH_SIZE} tickers, date range: ${start_date} to ${end_date}`)

        // Call all batches in parallel
        const results = await Promise.all(
            batches.map(batch => {
                const body = {
                    query: {
                        key: "prod",
                        tickers: batch,
                        start_date,
                        end_date,
                        method: "standard"
                    }
                }
                return axios
                    .post(`${emaHost}/ema-alerts`, body)
                    .then(r => r.data?.data || [])
                    .catch(e => {
                        console.log("EmaAlerts batch error:", e.message)
                        return []
                    })
            })
        )

        // Combine all batch results
        const allData = results.flat()
        console.log(`EmaAlerts: ${allData.length} total alerts from ${batches.length} batches`)
        return { data: allData }
    } catch (err) {
        console.log("Error in get_ema_alerts", err)
        return null
    }
}

const get_stored_alerts = async (date) => {
    const formattedDate = getTodayDate(date, "DD-MM-YYYY")

    const response = await axios
        .get(`${config.dataServer}/alert?date=${formattedDate}`)
        .then((response) => {
            return response.data
        })
        .catch((e) => {
            console.log("Error in set_alerts", e)
            return e.response.data
        })
    return response
}

const set_alerts = async (date, alerts) => {
    const formattedDate = getTodayDate(date, "DD-MM-YYYY")

    try {
        await axios.post(`${config.dataServer}/alert`, {
            date: formattedDate,
            alerts: JSON.stringify({
                momentumAlerts: alerts.pre_market_alerts,
                preMarketAlerts: alerts.momentum_alerts
            })
        })
    } catch (e) {
        console.log("Error in set_alerts", e)
    }
}

const save_user_portfolios = async (payload) => {
    const response = await axios
        .post(`${config.dataServer}/portfolio`, payload)
        .then((response) => {
            return response.data
        })
        .catch((e) => {
            console.log("Error in save_user_portfolios", e)
            return e.response.data
        })
    return response
}

const delete_user_portfolio = async (payload) => {
    const response = await axios
        .delete(`${config.dataServer}/portfolio`, { data: payload })
        .then((response) => {
            return response.data
        })
        .catch((e) => {
            console.log("Error in delete_user_portfolio", e)
            return e.response.data
        })
    return response
}

const get_user_portfolios = async (userId) => {
    try {
        const response = await axios.get(
            `${config.dataServer}/portfolio/${userId}`
        )
        return response.data
    } catch (e) {
        console.log("Error in get_user_portfolios", e)
        return { error: e.message }
    }
}

const get_user = async (id) => {
    try {
        const response = await axios.get(`${config.dataServer}/user?id=${id}`)
        return response.data
    } catch (e) {
        console.log("Error in get_user", e)
        return { error: e.message }
    }
}

const add_user = async (payload) => {
    try {
        const response = await axios.post(`${config.dataServer}/user`, payload)
        return response.data
    } catch (e) {
        return { error: e.response.data.message }
    }
}

// Update User
const update_user = async (payload) => {
    try {
        const response = await axios.patch(`${config.dataServer}/user`, payload)
        return response.data
    } catch (e) {
        return { error: e.response.data.message }
    }
}

const get_scroll_data = async (scroll_id) => {
    try {
        const body = { 
            scroll_id, 
            key,
            func_type:"dash-table-data",
            es_env: "staging"
        }
        const response = await axios
            .post(`${config.host}${config.urls.get_scroll}`, body)
            .then((response) => response.data)
            .catch((e) => {
                console.log("Data Retrieval Error (get-scroll):", e)
                return ""
            })
        return response
    } catch (err) {
        console.log("Error in get_scroll_data", err)
        return ""
    }
}

const api = {
    get_tickers,
    get_sectors,
    get_options,
    get_data,
    get_piecharts_data,
    get_dashtable_data,
    get_av_hic_data,
    get_gtrends_hic_data,
    get_ibm_news_data,
    get_stocktwits_data,
    get_composite_sentiment,
    get_graphs,
    get_market_status_graphs,
    get_reddit_data,
    get_edgar_data,
    get_alerts,
    get_ema_alerts,
    get_stored_alerts,
    set_alerts,
    get_bluesky_data,
    get_user_portfolios,
    save_user_portfolios,
    delete_user_portfolio,
    get_user,
    add_user,
    update_user,
    get_scroll_data
}

export default api
